import {useMemo} from 'react'
import {type CardStateUnordered} from '@colonist/game-states'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {getBankCardStackSize} from './getBankCardStackSize.ts'
import {CardDataController} from '@colonist/game-card-types'
import {useBankCardState} from './useBankCardState.ts'

export const useBankCardStackSizes = () => {
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const bankCardState = useBankCardState()

    return useMemo(() => {
        const stackSizes: CardStateUnordered = {}
        for(const [cardEnum, count] of Object.entries(bankCardState)) {
            const cardType = CardDataController.getCardDataForCard(Number(cardEnum))?.cardTypeEnum
            if(cardType == null) continue

            const stackSize = getBankCardStackSize(modeSetting, cardType, count)
            stackSizes[cardEnum] = stackSize
        }
        return stackSizes
    }, [bankCardState, modeSetting])
}
